// import { yupResolver } from '@hookform/resolvers/yup'
// import { Textarea } from '@nextui-org/react'
// import { Auth } from 'aws-amplify'
import { NextSeo } from 'next-seo'

// import AuthBg from '@/assets/illustrations/auth.svg'
// import bottomImg from '@/assets/illustrations/home.svg'
// import Button, { ButtonVariant } from '@/components/button'
// import Input from '@/components/input'
// import Link from '@/components/link'
// import handleApiError from '@/utils/handle-api-error'
// import ContactUs from '@/pages/contactUs'

const refundPolicy = () => {
  return (
    <div className='flex h-[100%] min-h-full flex-wrap items-center bg-theme-turquoise px-5'>
      <NextSeo title='Refund and Cancellation Policy' />
      <div className='h-bg-intr custom-page mt-[50px] flex-[0_0_100%]'>
        <div className='relative'>
          <ul className='custom-heading list-[circle]'>
            <li className=''>
              <h1 className='font-normal uppercase'>
                refund and cancellation policy
              </h1>
            </li>
          </ul>
          <div className='policy-container'>
            <div className='pt-4 md:pt-14'>
              <div>
                <p>
                  Thank you for purchasing a thrive skill course with us. We
                  want to make sure that our have an exceptional learning
                  experience online. As with any online purchase experience, the
                  below are the terms and conditions that govern the refund
                  policy. When you buy a course on the www.thrivecafe.in you
                  agree to our Privacy Policy, Terms of Use and the conditions
                  covered below.
                </p>
              </div>
              <div className='flex flex-wrap pt-4 md:pt-14'>
                <div>
                  <h3 className='pb-4 font-medium capitalize md:pb-14'>
                    cancellation and refunds: online training
                  </h3>
                  <p>
                    We understand that you can change your mind. That is why we
                    give you the freedom to ask for a partial refund depending
                    on the following criteria
                  </p>
                </div>
                <div>
                  <div className='pb-4 md:pb-14'>
                    <p className='font-medium'>
                      If the canellation is requested before commencement of the
                      classes.
                    </p>
                    <ul className='custom-margin ml-5 list-[circle] md:ml-9'>
                      <li>
                        If the cancellation requested by the customer within 24
                        hours of registration, but before commencement of
                        classes, 90% of course fee paid will be refunded
                      </li>
                      <li>
                        If the cancellation requested by the customer after 24
                        hours of registration, but before commencement of
                        classes, 80% of course fee paid will be refunded
                      </li>
                    </ul>
                  </div>
                  <div className='pb-4 md:pb-14'>
                    <p className='font-medium'>
                      If the canellation is requested after commencement of the
                      course.
                    </p>
                    <ul className='custom-margin ml-5 list-[circle] md:ml-9'>
                      <li>
                        If the cancellation request is made by the customer
                        within 24 hours of completion of 1st session, 75% of the
                        course fee would be refunded
                      </li>
                      <li>
                        If the cancellation request is made by the customer post
                        24 hours of completion of 1st session, no refund will be
                        applicable.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className='pb-4 md:pb-14'>
              <h3 className='pb-4 font-medium md:pb-14'>
                Refunds: Duplicate payment
              </h3>
              <p className='pb-4 md:pb-14'>
                Refund of the duplicate payment made by the customer will be
                processed via same source (original method of payment) within 7
                to 21 working days after intimation by the customer.
              </p>
              <p className='pb-4 font-medium md:pb-14'>
                Note: All refunds will be processed withing 15 working days of
                approval and validation of refund request.
              </p>
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          h3.contact-detail {
            margin-bottom: 20px;
          }
          .custom-page {
            padding-inline: calc(
              35px + (510 - 35) * (100vw - 375px) / (1920 - 375)
            );
            margin-bottom: calc(
              50px + (100 - 50) * (100vw - 375px) / (1920 - 375)
            );
          }
          .custom-heading {
            font-size: calc(12pt + (48 - 12) * (100vw - 375px) / (1920 - 375));
            margin-top: calc(
              50px + (155 - 50) * (100vw - 375px) / (1920 - 375)
            );
            margin-left: calc(
              18px + (38 - 18) * (100vw - 375px) / (1920 - 375)
            );
          }
          @media (max-width: 767px) {
            .custom-heading {
              margin-left: 14px;
            }
            .custom-margin {
              margin-left: 11px;
            }
          }
          form.custom-form-font {
            font-size: calc(11pt + (44 - 11) * (100vw - 375px) / (1920 - 375));
            line-height: calc(
              23pt + (69 - 23) * (100vw - 375px) / (1920 - 375)
            );
            font-weight: 200;
          }
          .quick-links {
            font-family: 'Overpass';
            font-weight: 300;
            font-size: 13px;
            line-height: 22px;
          }
          .py-custom {
            max-width: 524px;
            margin: 200px auto 20px;
          }
          @media (max-width: 1920px) {
            .py-custom {
              max-width: calc(
                320px + (524 - 320) * (100vw - 375px) / (1920 - 375)
              );
              margin: calc(115px + (200 - 115) * (100vw - 375px) / (1920 - 375))
                auto 20px;
            }
            .quick-links {
              font-size: calc(8pt + (25 - 12) * (100vw - 281pt) / (1920 - 375));
              line-height: calc(
                10pt + (30 - 15) * (100vw - 281pt) / (1920 - 375)
              );
            }
          }
          .policy-container {
            font-weight: 200;
            font-size: calc(9pt + (27 - 9) * (100vw - 281pt) / (1920 - 375));
            line-height: calc(
              12pt + (25 - 12) * (100vw - 281pt) / (1920 - 375)
            );
            margin-bottom: calc(
              8pt + (25 - 12) * (100vw - 281pt) / (1920 - 375)
            );
          }
        `}
      </style>
    </div>
  )
}
export default refundPolicy
